import Base from './base';

class Logo extends Base {
	start() {
		const img = this.query('img');

		// Force display of logo if it has zero sizing
		// For example if the linked svg has no width and height properties set
		if (img && img.clientWidth === 0 && img.clientHeight === 0) {
			img.classList.add('logo__image-default-height');
		}
	}
}

export default Logo;
